import { render, staticRenderFns } from "./templateTitleDialog.vue?vue&type=template&id=70835768"
import script from "./templateTitleDialog.vue?vue&type=script&lang=ts"
export * from "./templateTitleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports